/*
  Jack N Elliot Studio — French price format on the storefront.
  Shopify has a single money format for the whole store ("$17.00"); Québec French writes "17,00 $".
  Loaded on French pages only (layout/theme.liquid). Rewrites visible text, including prices that
  themes and apps update later (cart drawer, roster totals, Live Product Options), and never touches
  form fields, scripts or attributes.
*/
(function () {
  'use strict';

  var PRICE = /\$\s?(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d{2}))?(\s?CAD)?/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, TEMPLATE: 1 };

  function toFrench(match, whole, cents, cad) {
    var amount = whole.replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (cents) amount += ',' + cents;
    return amount + ' $' + (cad ? ' CAD' : '');
  }

  function fixText(node) {
    var text = node.nodeValue;
    if (!text || text.indexOf('$') === -1) return;
    var parent = node.parentNode;
    if (!parent || SKIP[parent.nodeName] || (parent.closest && parent.closest('[contenteditable], [data-jne-keep-money]'))) return;
    PRICE.lastIndex = 0;
    if (!PRICE.test(text)) return;
    PRICE.lastIndex = 0;
    node.nodeValue = text.replace(PRICE, toFrench);
  }

  function fixTree(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) fixText(node);
  }

  function start() {
    fixTree(document.body);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') fixText(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) fixTree(m.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
